import { toggleLoginModal } from "@redux/actions/profileActions";
import { RootState } from "@redux/store";
import { SegmentEventName } from "@tsTypes/__generated__/enums";
import { LoginModalPreviousAction } from "@tsTypes/redux";
import { track } from "@utils/appUtils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BlankModal from "../library/ModalBases/BlankModal";
import LoginModal from "./LoginModal";
import SignUpModal from "./SignUpModal/SignUpModal";

export type LoginSignUpModalType = "signup" | "login";

function LoginSignUpModal() {
  const { isOpen, previousAction, initialView } = useSelector(
    (state: RootState) => state.profiles.loginModalState
  );

  const [modalType, setModalType] = useState<LoginSignUpModalType>(
    initialView ?? (previousAction === LoginModalPreviousAction.ADD_TO_NETWORK ? "login" : "signup")
  );

  // Ensure the correct modal opens when the state changes while mounted
  useEffect(() => {
    if (!isOpen) return;

    const nextType: LoginSignUpModalType =
      (initialView as LoginSignUpModalType | undefined) ??
      (previousAction === LoginModalPreviousAction.ADD_TO_NETWORK ? "login" : "signup");
    setModalType(nextType);
  }, [isOpen, previousAction, initialView]);

  const dispatch = useDispatch();

  const closeLoginModal = () => {
    dispatch(toggleLoginModal({ open: false }));
  };

  if (isOpen) {
    track(SegmentEventName.VIEW, {
      ui_component: "Login Modal",
    });
  }

  return (
    <BlankModal
      isOpen={isOpen}
      onClose={closeLoginModal}
      width={modalType === "signup" ? "680px" : "450px"}
      height={modalType === "signup" ? "fit-content" : "551px"}
      hideCloseButton={modalType === "login"}
    >
      <div data-testid="login-modal">
        {modalType === "signup" && <SignUpModal setModalType={setModalType} />}
        {modalType === "login" && <LoginModal setModalType={setModalType} compat />}
      </div>
    </BlankModal>
  );
}

export default LoginSignUpModal;
